module.exports = __webpack_public_path__ + "img/view-bg-id12.7783e3e7.png";